<template>
    <div class="row mb-5">
        <div class="col-12 min-height-100 text-center p-3 d-flex justify-content-center align-items-center">
            <div class="spinner-border m-5 p-3" role="status"></div>
        </div>
        <div class="text-center mx-auto">
            <h2>Gathering your results</h2>
            <p>this may take a few seconds</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'results-loading',
    data() {
        return {}
    },
}
</script>
